import React from 'react';
import PropTypes from 'prop-types';

import EventContextMenu from './event-context-menu';
import ChartContextMenu from './chart-context-menu';
import WebserviceContextMenu from './webservice-context-menu';
import PersonalSpaceContextMenu from './personal-space-context-menu';
import PartnerContextMenu from './partner-context-menu';
import TicketOfficeContextMenu from './ticket-office-context-menu';
import ModerationContextMenu from './moderation-context-menu';
import OnlineTicketingContextMenu from './online-ticketing-context-menu';
import ProductContextMenu from './product-context-menu';

export default function ContextMenu({ organization, event, chart, partner, webservice, ticket_office, moderationFlowId, personal_space, product, ticket_shop, ...rest }) {
    const Component = React.useMemo(() => {
        if (!event && !partner && !ticket_office && !chart && !webservice && !moderationFlowId && !personal_space && !product && !ticket_shop) {
            // Organization
            return null;
        }
        if (!partner && !ticket_office && !chart && !webservice && !moderationFlowId && !personal_space && !product && !ticket_shop) {
            // Event
            return EventContextMenu;
        }

        if (ticket_office) {
            return TicketOfficeContextMenu;
        }

        if (chart) {
            return ChartContextMenu;
        }

        if (webservice) {
            return WebserviceContextMenu;
        }

        if (moderationFlowId) {
            return ModerationContextMenu;
        }

        if (personal_space) {
            return PersonalSpaceContextMenu;
        }

        if (product) {
            return ProductContextMenu;
        }

        if (ticket_shop) {
            return OnlineTicketingContextMenu;
        }

        // Partner
        return PartnerContextMenu;
    }, [organization, event, chart, webservice, partner, ticket_office, personal_space, product, moderationFlowId, ticket_shop]);

    if (!event && !partner && !ticket_office && !chart && !webservice && !moderationFlowId && !personal_space && !product && !ticket_shop) {
        return null;
    }

    return (
        <Component
            organization={organization}
            event={event}
            chart={chart}
            webservice={webservice}
            partner={partner}
            ticket_office={ticket_office}
            moderationFlowId={moderationFlowId}
            personal_space={personal_space}
            product={product}
            ticket_shop={ticket_shop}
            {...rest}
        />
    );
}

ContextMenu.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object,
    partner: PropTypes.object,
    ticket_office: PropTypes.object,
    product: PropTypes.object,
    webservice: PropTypes.object
};
